import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateMultiplierType($companyId: ID!, $attributes: MultiplierTypeAttributes!) {
    createMultiplierType(companyId: $companyId, attributes: $attributes) {
       multiplierType {
        id
        ...CreatedMultiplierType
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedMultiplierType on MultiplierType {
    id
    name
    multiplier
    multiplierType
    operandQuantity
    operandType
  }
`
